<wizard-labeled-field label="Location" [size]="fieldSize">
    <wizard-tooltip>
        The location field can be used to enter an address, a phone number or a static video conferencing URL. The
        default for this setting comes from your associated Meeting Type.
    </wizard-tooltip>
    <input
        type="text"
        placeholder="Enter a Location, Phone number or Conferencing URL"
        name="location"
        [ngModel]="location"
        (ngModelChange)="updateLocation($event)"
        (keyup)="handleKeyup()"
    />
</wizard-labeled-field>
